import React, { Component } from "react";
import{userServices} from "../../services/user.service";
import notify from 'devextreme/ui/notify';

export default class Logout extends Component {
  constructor(props) {
    super(props);
    userServices.logout();
    notify({position:'top right', message:'Logout successfully',type:'success',maxWidth:200});
    this.props.history.push('/login');
  }

  render() {
    return (
      <div></div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Logout.js